export var ToastType;
(function (ToastType) {
    ToastType["Error"] = "error";
    ToastType["Info"] = "info";
})(ToastType || (ToastType = {}));
